import React from 'react';
import ReactCodeInput from 'react-verification-code-input';

import { CodeInputProps } from '../types';
import { InputWrapper } from './codeInput.style'

const CodeInput: React.FC<CodeInputProps> = ({className, onChange, invalid = false, fields = 4}) => {
    return (
        <InputWrapper className={className} invalid={invalid}>
            <ReactCodeInput onChange={onChange} fields={fields}/>
        </InputWrapper>
    )
}

export { CodeInput }